import * as React from "react"
import {map as _map} from "lodash"
import {AppConstants} from "../utils/AppConstants";

export interface WeekdaySelectorProps {
    disabled?: boolean;
    selectedDays: string[],
    onSelect: (days: string[]) => void
}

class WeekdaySelector extends React.Component<WeekdaySelectorProps> {
    constructor(props: WeekdaySelectorProps) {
        super(props);
    }

    modifySelectedDays = (day: string) => {
        let isDisabled = this.props.disabled !== undefined && this.props.disabled;
        if (!isDisabled) {
            let selectedDays = [ ...this.props.selectedDays ];
            if (selectedDays.indexOf(day) !== -1) {
                selectedDays.splice(selectedDays.indexOf(day), 1);
            } else {
                selectedDays.push(day);
            }
            this.props.onSelect(selectedDays);
        }
    }

    render() {
        let selectedDays = this.props.selectedDays;
        return (
            <div>
                {
                    _map(AppConstants.WeekdaysConstant, (day, key) => {
                        let cssClass = selectedDays.indexOf(day) !== -1 ? "active" : "";
                        return <div key={key} className={`weekday-btn ${cssClass}`} tabIndex={0} onClick={() => this.modifySelectedDays(day)}>{key[0]}</div>
                    })
                }
            </div>
        )
    }
}

export default WeekdaySelector;